import React, { useEffect, useState } from "react";
import { CustomerCompanyContact } from "../model/CustomerCompanyContactModel";
import { Card, FloatingLabel, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Column, Select } from "../../components";
import TextInputWithLabelInline from "../../shared/components/input/TextInputWithLabelInline";
import DropDownWithLabelInline from "../../shared/components/input/DropDownWithLabelInline";
import { ConfirmModal } from "../../shared/components/confirmModal";
import * as label from '../../shared/util/label';
import * as constant from '../../shared/util/constant';
import FormattedInputWithLableInline, { InputFormatType } from "../../shared/components/input/formatted-input/FormattedInputWithLableInline";
import { SelectOption } from "../../shared/components/input";
import { useConfirmationModalContext } from "../../shared/components/ModalConfirmationContext";
import Button from 'react-bootstrap/Button';
import { FloatLabel } from 'primereact/floatlabel'
import { InputMask } from 'primereact/inputmask';
import CustomerDetailService from "./CustomerDetailService";
import TextInputWithZipCode from "../../shared/components/input/TextInputWithZipCode";

export interface ICustomerCompanyContactView {
    index: number,
    contact: CustomerCompanyContact,
    countries: SelectOption[],
    onFieldChange: (collectionPropName: string, collectionEntityIdentifierPropName: string, collectionEntityIdentifierValue: any, propName: string, value: string | Date | boolean) => void,
    onDelete: (dependent: CustomerCompanyContact) => void,
    formValidations: any
    isEditable: boolean,
    isReset: boolean,
    divToScroll: any,
    counter: any,
    updateCounter?: (lastTabIndex: any) => void,
    statesUS:SelectOption[],
    statesCanada:SelectOption[],
    resetVal:any
}

const CustomerCompanyContactView: React.FunctionComponent<ICustomerCompanyContactView> = (props) => {
    let tbIndex = props.counter;
    const customerDetailService = new CustomerDetailService();
    const cont = props.contact;
    const formValidations = props.formValidations;
    const [contact, setContact] = useState<CustomerCompanyContact>({});
    const [formValidation, setFormValidation] = useState<any>({});
    // TODO : Remove once modal handler implemented
    const [showTooltip, setShowTooltip] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState<boolean>(false);
    const [initialContact, setInitialDependent] = useState<CustomerCompanyContact>(cont);
    const modalContext = useConfirmationModalContext();
    const removeContact = () => {
        setShowDeleteConfirmation(false);
        props.onDelete(contact);
    }
    const [states,setStates] = useState<SelectOption[]>([]);
    const [isUSA,setIsUSA] = useState(false);

    useEffect(() => {
        // Move updateCounter to run after all controls are rendered
        if (tbIndex) {
            props.updateCounter(tbIndex);
            //alert(tbIndex);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        setContact(initialContact);
    }, [props.isReset]);

    useEffect(() => {
        setContact(cont);
    }, []);

    useEffect(() => {
        setFormValidation(formValidations ? formValidations : {});
    }, [formValidations]);

    useEffect(()=>{
        if((contact.countryId === constant.DATA_IDs.COUNTRIES.USA || contact.countryId == null)){
            setStates(  props.statesUS);
            setIsUSA(true);

        }
        else if(contact.countryId === constant.DATA_IDs.COUNTRIES.CANADA){
            setStates(  props.statesCanada)
            setIsUSA(false);

        }
    },[props.statesUS, props.statesCanada, contact.countryId])

    const tooltip = (
        <Tooltip id="tooltip"> {constant.ZIPCODE_TOOLTIP} </Tooltip>
    );

    //const isEditable = true;
    const handleChangeZipCodeOnBlur = (propName: string, val: string) => {
        if (val) {
            let validationErrors = customerDetailService.validationForZipCode(propName, val,isUSA )
            if (Object.keys(validationErrors).length > 0) {
                setFormValidation({ ...formValidation, ...validationErrors })
            } else {
                const newObject = { ...formValidation };
                delete newObject[propName];
                setFormValidation(newObject);
            }
        }
    };

    const onEntityFieldChange = (propName: string, value: string | Date | boolean) => {
        if (propName === 'workPhoneExt') {
            if (value.toString().length > 5)
                return false;
            else {
                value = value.toString().replace(/[^0-9]/g, "")
            }
        }

        setContact({
            ...contact,
            [propName]: value,
        });
        props.onFieldChange('customerContacts', 'id', contact.id, propName, value);

        if (propName.toLocaleLowerCase() == 'zip') {
            let val = zipCodeFormat(value);
            setContact({
                ...contact,
                [propName]: val,
            });
        }
        if(propName.toLocaleLowerCase()=='state'){
            
            setContact((prev:any)=>{
                const updated = {
                ...prev,
                "state":value,
                "city":null,
                "zip":null
            }
            return updated
            });

            props.resetVal('customerContacts', 'id', contact.id, "state", value);
        }
    }
    const zipCodeFormat = (value: string): any => {
       
       if(isUSA != false){ let val = value.toString().replace(/[^0-9-]/g, ''); // Remove non-digit and non-hyphen characters
        val = val.replace(/-/g, ''); // Remove existing hyphens

        if (value.toString().length > 5) {
            val = val.slice(0, 5) + '-' + val.slice(5); // Add hyphen after 5 characters
        }
        return val.slice(0, 10); // Limit to 10 characters including hyphen
         }
        else{
           let val= value.toString().replace(/[^A-Za-z0-9\- ]/g, '');
           return val;
        }
    }
    const onDeleteContact = async () => {
        const result = await modalContext.showConfirmation(constant.CONFIRM_CONTACT_DELETE)
        if (result) {
            removeContact();
        }
    }

     const onCountrySelection = (countrySelected: string) => {
            setIsUSA(false);

            setContact({
            ...contact,
             "countryId": countrySelected,
             "city":null,
             "state":null,
             "zip":null
        });

            props.resetVal('customerContacts', 'id', contact.id, "country", countrySelected);

            if (countrySelected == constant.DATA_IDs.COUNTRIES.USA) {
                setStates(props.statesUS);
                setIsUSA(true);
            }
            else if (countrySelected == constant.DATA_IDs.COUNTRIES.CANADA) {
                setStates(props.statesCanada)
                setFormValidation((prev: any) => ({
                    ...prev,
                    state: { isValid: true, warningText: null }
                }));
            }
            else {
                setStates([]);
                setFormValidation((prev: any) => ({
                    ...prev,
                    state: { isValid: true, warningText: null }
                }));
            }
    
        }

    return (
        <>
            <div className="cd-main-container mb-2" ref={props.divToScroll}>
                <Card>
                    <Card.Header>
                        <div
                            className="panel-title d-flex align-items-center"
                            data-index-value={props.index === 0 ? tbIndex = 201 : tbIndex = (201 + (props.index * 20))}
                        >
                            {props.index + 1}. Company Contact
                            <Button
                                onClick={onDeleteContact}
                                variant="light"
                                size="sm"
                                className="ms-auto"
                                disabled={!props.isEditable}
                                id="btnContactDel"
                                tabIndex={tbIndex++}
                            >
                                <i className="bi bi-trash-fill"></i>
                            </Button>
                        </div>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Column lg={8} md={8}
                                className={formValidation['contactName']?.isValid == false ? 'feedback-row' : ''}>
                                <FloatingLabel
                                    controlId="contactName"
                                    label={<>
                                        {label.CustomerScreentLables.NAME}
                                        <span className="text-danger">*</span>
                                    </>}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="contactName"
                                        value={contact.contactName ?? ""}
                                        onChange={(event) => onEntityFieldChange('contactName', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        required
                                        maxLength={75}
                                        isInvalid={formValidation['contactName']?.isValid == false}
                                    />
                                    {formValidation['contactName']?.isValid == false && (
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['contactName']?.warningText}
                                        </Form.Control.Feedback>
                                    )}
                                </FloatingLabel>
                            </Column>

                            <Column lg={4} md={4}
                                className={formValidation['title']?.isValid == false ? 'feedback-row' : ''}>
                                <FloatingLabel
                                    controlId="title"
                                    label={<>
                                        {label.CustomerScreentLables.TITLE}
                                        <span className="text-danger">*</span>
                                    </>}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="title"
                                        value={contact.title ?? ""}
                                        onChange={(event) => onEntityFieldChange('title', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        required
                                        maxLength={75}
                                        isInvalid={formValidation['title']?.isValid == false}
                                    />
                                    {formValidation['title']?.isValid == false && (
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['title']?.warningText}
                                        </Form.Control.Feedback>
                                    )}
                                </FloatingLabel>
                            </Column>
                        </Row>
                        <Row>
                            <Column lg={6} md={6}
                                className={formValidation['email']?.isValid == false ? 'feedback-row' : ''}>
                                <FloatingLabel
                                    controlId="email"
                                    label={label.CustomerScreentLables.EMAIL}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="email"
                                        placeholder=" "
                                        name="email"
                                        value={contact.email ?? ""}
                                        onChange={(event) => onEntityFieldChange('email', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        maxLength={100}
                                        isInvalid={formValidation['email']?.isValid == false}
                                    />
                                    {formValidation['email']?.isValid == false && (
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['email']?.warningText}
                                        </Form.Control.Feedback>
                                    )}
                                </FloatingLabel>
                            </Column>
                            <Column lg={6} md={6}>
                                <FloatingLabel
                                    controlId="webAddr"
                                    label={label.CustomerScreentLables.WEB_ADDRESS}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="webAddr"
                                        value={contact.webAddr ?? ""}
                                        onChange={(event) => onEntityFieldChange('webAddr', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        maxLength={150}
                                    />
                                </FloatingLabel>
                            </Column>
                        </Row>

                        <Row>
                            {/* Left side - 5 columns */}
                            <Column lg={5} md={5}
                                className={formValidation['workPhone']?.isValid == false ? 'feedback-row' : ''}>
                                <div className="d-flex gap-0">
                                    <div className="flex-grow-1">
                                        <FloatingLabel controlId="workPhone" label={<>
                                            {label.CustomerScreentLables.WORK_PHONE}
                                            <span className="text-danger">*</span>
                                        </>} className="mb-3"
                                        >
                                            <InputMask
                                                id="companyWorkPhone"
                                                name="workPhone"
                                                className={`remove-right-radius  ${(!formValidation['workPhone']?.isValid && Object.keys(formValidation).length != 0)?'is-invalid':''}`}
                                                required={true}
                                                disabled={!props.isEditable}
                                                value={contact.workPhone ?? ""}
                                                onChange={(event) => onEntityFieldChange('workPhone', event.value)}
                                                mask="999-999-9999"
                                                autoClear={false}
                                                tabIndex={tbIndex++}
                                                placeholder={label.CustomerScreentLables.WORK_PHONE} />
                                            {formValidation['workPhone']?.isValid == false && (
                                                <Form.Control.Feedback type="invalid">
                                                    {formValidation['workPhone']?.warningText}
                                                </Form.Control.Feedback>
                                            )}
                                        </FloatingLabel>


                                    </div>

                                    <div style={{ width: '100px' }}>
                                        <FloatingLabel
                                            controlId="workPhoneExt"
                                            label={label.CustomerScreentLables.EXT}
                                            className="mb-3"
                                        >
                                            <Form.Control
                                                tabIndex={tbIndex++}
                                                type="text"
                                                placeholder=" "
                                                name="workPhoneExt"
                                                className="remove-left-radius"
                                                value={contact.workPhoneExt ?? ""}
                                                onChange={(event) => onEntityFieldChange('workPhoneExt', event.currentTarget.value)}
                                                disabled={!props.isEditable}
                                                maxLength={5}
                                            />
                                        </FloatingLabel>
                                    </div>
                                </div>
                            </Column>
                            {/* Right side - 7 columns */}
                            <Column lg={7} md={7}>
                                <Row className="mb-3">
                                    <Column lg={6} md={6}
                                        className={formValidation['mobile']?.isValid == false ? 'feedback-row' : ''}>
                                        <FloatLabel>
                                            <InputMask
                                                id="mobile"
                                                name="mobile"
                                                value={contact.mobile ?? ""}
                                                disabled={!props.isEditable}
                                                onChange={(event) => onEntityFieldChange('mobile', event.value)}
                                                mask="999-999-9999"
                                                autoClear={false}
                                                tabIndex={tbIndex++}
                                                className={formValidation['mobile']?.isValid == false ? 'p-invalid' : ''}
                                                placeholder={label.CustomerScreentLables.CELL_PHONE} />
                                            <label>{label.CustomerScreentLables.CELL_PHONE}</label>
                                        </FloatLabel>
                                        {formValidation['mobile']?.isValid == false && (
                                            <div className="invalid-feedback d-block mt-1">
                                                {formValidation['mobile']?.warningText}
                                            </div>
                                        )}
                                    </Column>

                                    <Column lg={6} md={6}
                                        className={formValidation['homePhone']?.isValid == false ? 'feedback-row' : ''}>
                                        <FloatLabel>
                                            <InputMask
                                                id="homePhone"
                                                name="homePhone"
                                                disabled={!props.isEditable}
                                                value={contact.homePhone ?? ""}
                                                onChange={(event) => onEntityFieldChange('homePhone', event.value)}
                                                mask="999-999-9999"
                                                autoClear={false}
                                                tabIndex={tbIndex++}
                                                className={formValidation['homePhone']?.isValid == false ? 'p-invalid' : ''}
                                                placeholder={label.CustomerScreentLables.HOME_PHONE} />
                                            <label>{label.CustomerScreentLables.HOME_PHONE}</label>
                                        </FloatLabel>
                                        {formValidation['homePhone']?.isValid == false && (
                                            <div className="invalid-feedback d-block mt-1">
                                                {formValidation['homePhone']?.warningText}
                                            </div>
                                        )}

                                    </Column>
                                </Row>
                            </Column>
                        </Row>

                        
                        {/* Address Line 1 */}
                        <Row>
                              {/* adding country dropdown: by neeraj.u */}
                            <Column lg={4} md={3}>
                               <Select
                                 id="country"
                                 controlId="country"
                                 label={label.CustomerScreentLables.COUNTRY}
                                 options={props.countries}
                                 defaultSelected={props.countries?.filter(({ value }) => value === (contact.countryId ??  props.countries.find(x=> x.value == constant.DATA_IDs.COUNTRIES.USA).value))}
                                 onChange={
                                     (values) => {
                                         onCountrySelection(values[0] as string)
                                     }
                                 }
                                 disabled={!props.isEditable}
                                tabIndex={tbIndex++}
                                 className='mb-3'
                             />
                            </Column>
                            <Column lg={4} md={8}>
                                <FloatingLabel
                                    controlId="address1"
                                    label={label.CustomerScreentLables.ADDRESS_1}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="address1"
                                        value={contact.address1 ?? ""}
                                        onChange={(event) => onEntityFieldChange('address1', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        maxLength={75}
                                    />
                                </FloatingLabel>
                            </Column>

                            <Column lg={4} md={4}>
                                <FloatingLabel
                                    controlId="address2"
                                    label={label.CustomerScreentLables.ADDRESS_2}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="address2"
                                        value={contact.address2 ?? ""}
                                        onChange={(event) => onEntityFieldChange('address2', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        maxLength={75}
                                    />
                                </FloatingLabel>
                            </Column>
                       
                            <Column lg={5} md={5} className={formValidation['city']?.isValid == false ? 'feedback-row' : ''}>
                                <FloatingLabel
                                    controlId="city"
                                    label={<>{label.CustomerScreentLables.CITY}
                                    <span className="text-danger ms-1">*</span>
                                    </>}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="city"
                                        value={contact.city ?? ""}
                                        onChange={(event) => onEntityFieldChange('city', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        maxLength={30}
                                        isInvalid={formValidation['city']?.isValid == false}
                                        required={true}
                                    />
                                     {formValidation['city']?.isValid == false && (
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['city']?.warningText}
                                        </Form.Control.Feedback>
                                    )}
                                </FloatingLabel>
                            </Column>

                            <Column lg={3} md={3}>
                               {(contact.countryId == constant.DATA_IDs.COUNTRIES.USA || contact.countryId == constant.DATA_IDs.COUNTRIES.CANADA) || states.length >0 ?<Select
                                    tabIndex={tbIndex++}
                                    id="state"
                                    controlId="state"
                                    className='mb-3'
                                    label={<>{label.CustomerScreentLables.STATE} {states.length > 0 && <span className="text-danger ms-1">*</span>}</>}
                                    options={states}
                                    defaultSelected={states.filter(option =>
                                        option.value === contact.state
                                    )}
                                    onChange={(values) => onEntityFieldChange('state', values[0] as string)}
                                    disabled={!props.isEditable}
                                    isInvalid={formValidation['state']?.isValid == false}
                                    invalidWarning={formValidation['state']?.warningText}
                                /> :
                                <FloatingLabel
                                    controlId="txtState"
                                    label={<>
                                        {label.CustomerScreentLables.STATE}
                                    </>}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="text"
                                        placeholder=" "
                                        name="state"
                                        value={contact.state ?? ""}
                                        onChange={(event) => onEntityFieldChange('state', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        tabIndex={tbIndex++}
                                        maxLength={100}
                                        isInvalid={formValidation['state']?.isValid == false}
                                    />
                                    {formValidation['state']?.isValid == false && (
                                        <Form.Control.Feedback type="invalid">
                                            {formValidation['state']?.warningText}
                                        </Form.Control.Feedback>
                                    )}
                                </FloatingLabel>}

                            </Column>

                            <Column lg={2} md={2}
                                className={formValidation['zip']?.isValid == false ? 'feedback-row' : ''}>
                                <TextInputWithZipCode
                                    name="contactZip"
                                    label={label.CustomerScreentLables.ZIP}
                                    controlId="zip"
                                    value={contact.zip ?? ""}
                                    onChange={(event) => {
                                        onEntityFieldChange('zip', event.currentTarget.value);
                                    }}
                                    onBlur={(e) => handleChangeZipCodeOnBlur('zip', contact.zip)}
                                    disabled={!props.isEditable}
                                    tabIndex={tbIndex++}
                                    maxLength={isUSA ? 10 : 9}
                                    isInvalid={formValidation['zip']?.isValid == false}
                                    invalidWarning={formValidation['zip']?.warningText} type={'text'}
                                    isUSA={isUSA}
                                    required
                                />
                            </Column>
                            <Column lg={2} md={2}>
                                <FloatingLabel
                                    controlId="county"
                                    label={label.CustomerScreentLables.COUNTY}
                                    className="mb-3"
                                >
                                    <Form.Control
                                        tabIndex={tbIndex++}
                                        type="text"
                                        placeholder=" "
                                        name="county"
                                        value={contact.county ?? ""}
                                        onChange={(event) => onEntityFieldChange('county', event.currentTarget.value)}
                                        disabled={!props.isEditable}
                                        maxLength={30}
                                    />
                                </FloatingLabel>
                            </Column>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </>
    );
}

export default CustomerCompanyContactView;